import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';
import PromoMessage from '../promo-message';

class Component extends BaseComponent {
    componentWillMount() {
        this.signs_map = {
            general: 0,
            aries: 1,
            taurus: 2,
            gemini: 3,
            cancer: 4,
            leo: 5,
            virgo: 6,
            libra: 7,
            scorpio: 8,
            sagittarius: 9,
            capricorn: 10,
            aquarius: 11,
            pisces: 12,
        };

        let sign = this.props.sign || 'general';

        if (this.props.user.logged_in && !this.props.sign) {
            sign = this.props.signs[this.props.user.default_sign - 1].name;
        }

        this.setState({ sign: sign });
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.user.logged_in != this.props.user.logged_in) {
            if (nextProps.user.logged_in && !this.props.sign) {
                this.setState({ sign: this.props.signs[nextProps.user.default_sign - 1].name });
            } else if (!nextProps.user.logged_in && !this.props.sign) {
                this.setState({ sign: 'general' });
            }
        }

        return true;
    }

    render({ horoscopes, date }) {
        const last_week = moment().day(1).subtract(1, 'week').format('YYYY-MM-DD');
        const this_week = moment().day(1).format('YYYY-MM-DD');
        const next_week = moment().day(1).add(1, 'week').format('YYYY-MM-DD');

        if (horoscopes) {
            return (
                <weekly-love-horoscope date={date}>
                    <div class='daily-links'>
                        <a
                          href={`/astrology/weekly-love-horoscopes/${this.state.sign}/${last_week}`}
                          class={last_week == date ? 'selected' : ''}
                        >
                            Last Week
                        </a>
                        <a
                          href={`/astrology/weekly-love-horoscopes/${this.state.sign}/${this_week}`}
                          class={this_week == date ? 'selected' : ''}
                        >
                            This Week
                        </a>
                        <a
                          href={`/astrology/weekly-love-horoscopes/${this.state.sign}/${next_week}`}
                          class={next_week == date ? 'selected' : ''}
                        >
                            Next Week
                        </a>
                    </div>
                    {this.renderH1()}
                    <div class='daily-links'>
                        <a href='/bios/maria-desimone'>by Maria DeSimone</a>
                    </div>
                    <br />
                    {this.renderHoroscope()}
                </weekly-love-horoscope>
            );
        }

        return null;
    }

    renderH1 = () => {
        return (
            <h1>{this.state.sign.charAt(0).toUpperCase() + this.state.sign.slice(1)} Weekly Love Horoscope</h1>
        );
    }

    renderHoroscope = () => {
        return [
            <p>
                <b>Week of {moment(this.props.date).format('dddd, MMMM D')}: </b>
                {this.props.horoscopes[this.signs_map[this.state.sign]].content}
            </p>,
            <p>
                <PromoMessage placement='text-love-horoscope' />
            </p>,
        ];
    }
}

const mapStateToProps = (state) => ({
    horoscopes: state['weekly-love-horoscopes'],
    signs: state.zodiac && state.zodiac.signs,
    user: state.user,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/weekly/love-horoscope.js